


























import Vue from 'vue';
import SpeakerWithGradient from '@/components/SpeakerWithGradient.vue';

export default Vue.extend({
  name: 'Contact',
  components: {
    SpeakerWithGradient,
  },
});
